import React from "react";
import { RightOutlined, CheckOutlined, CloseOutlined, EnvironmentOutlined } from "@ant-design/icons";

function Fact({ children }) {
  if (children == null || children === "") return null;
  return <span className="listing-card__fact">{children}</span>;
}

function isActive(record) {
  return record?.status === 1 || record?.status === "1" || record?.status === "active";
}

export function FacilityListingCard({ record, onClick, actions }) {
  const name = record?.name ?? record?.facility_name ?? "—";
  const code = record?.facility_code ?? record?.code ?? "—";
  const location = [record?.city, record?.state].filter(Boolean).join(", ");
  const active = isActive(record);

  return (
    <article
      className="listing-card listing-card--linear facility-listing-card"
      onClick={onClick}
      onKeyDown={onClick ? (e) => e.key === "Enter" && onClick() : undefined}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="listing-card__lead">
        <div className="listing-card__icon is-facility" aria-hidden>
          <EnvironmentOutlined />
        </div>
        <div className="listing-card__identity">
          <h3 className="listing-card__title">{name}</h3>
          <p className="listing-card__meta">{code}</p>
        </div>
      </div>

      <div className="listing-card__facts">
        <Fact>{location || "—"}</Fact>
        {record?.facility_type ? <Fact>{record.facility_type}</Fact> : null}
        {record?.phone ? <Fact>{record.phone}</Fact> : null}
      </div>

      <div className="listing-card__aside" onClick={(e) => e.stopPropagation()}>
        <span className={`listing-card__status ${active ? "is-active" : "is-inactive"}`}>
          {active ? <CheckOutlined /> : <CloseOutlined />}
          {active ? "Active" : "Inactive"}
        </span>
        {actions}
        {onClick ? <RightOutlined className="listing-card__chevron" aria-hidden /> : null}
      </div>
    </article>
  );
}

export default FacilityListingCard;
